import FocusTrap from 'focus-trap-react';
import * as React from 'react';
import { handleEnterKeyPress, handleEscKeyDown } from '../../Accessibility/KeyboardEvents';
import clickOutsideStore from '../../ClickOutsideStore';
import ModalBody from './ModalBody';
import VerticalMenuIcon from '../Cutesies/VerticalMenuIcon';
import { Maybe } from 'maybeasy';
import { equals, mapMaybe } from '@execonline-inc/collections';
import { identity } from '@kofno/piper';
import { fromArrayMaybe } from 'nonempty-list';
import { when } from '@execonline-inc/maybe-adapter';

type State = {
  isOpen: boolean;
};

export interface Props {
  children: ReadonlyArray<Maybe<React.ReactNode>>;
  disabled?: boolean;
  intercomTarget?: string;
}

class ActionMenu extends React.Component<Props> {
  actionItemsRef: React.RefObject<HTMLDivElement | null> = React.createRef();
  state: State = {
    isOpen: false,
  };

  close = () => {
    this.setState({ isOpen: false });
  };

  open = () => {
    clickOutsideStore.addListener({
      ref: this.actionItemsRef,
      callback: this.close,
    });
    this.setState({ isOpen: true });
  };

  render() {
    const { isOpen } = this.state;
    const { children } = this.props;
    return fromArrayMaybe(mapMaybe(identity, children))
      .map((body) => (
        <FocusTrap
          active={isOpen}
          focusTrapOptions={{
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: '#actionItems-container',
            preventScroll: true,
          }}
        >
          <div className="relative flex" ref={this.actionItemsRef}>
            <button
              data-test-action-menu
              data-intercom-target={this.props.intercomTarget || 'action-menu'}
              onClick={this.open}
              id="actionItems-container"
              tabIndex={0}
              onKeyPress={handleEnterKeyPress(this.open)}
              onKeyDown={handleEscKeyDown(this.close)}
              disabled={this.props.disabled}
              className="px-2 w-full"
              aria-label="Actions"
            >
              {when(equals(this.props.disabled, true), {})
                .map(() => <VerticalMenuIcon fill="#d1d5db" />)
                .getOrElse(() => (
                  <VerticalMenuIcon />
                ))}
            </button>
            <ModalBody isOpen={this.state.isOpen} close={this.close} body={body} />
          </div>
        </FocusTrap>
      ))
      .getOrElse(() => <></>);
  }
}

export default ActionMenu;
